import { Box, Stack, Typography } from "@mui/material";
import CopyLinkRow from "./CopyLinkRow";
import LookupChip from "./LookupChip";
import ProgressBar from "./ProgressBar";

export default function InitiativeDetailFields({ initiative }) {
  const styles = {
    description: { mb: 3, overflowWrap: "anywhere" },
    detailGrid: { display: "flex", gap: 3, mb: 3 },
    detailCol: {
      flex: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      gap: 2,
    },
    linkStack: { gap: 0.25 },
    detailLabel: {
      fontWeight: 700,
      fontSize: "0.7rem",
      color: "background.textMuted",
      textTransform: "uppercase",
      letterSpacing: "0.07em",
      mb: 0.5,
    },
    chipsBox: { display: "flex", flexWrap: "wrap", gap: 0.5, mt: 0.5 },
    ownerText: { overflowWrap: "anywhere" },
  };

  return (
    <>
      <Typography variant="body1" sx={styles.description}>
        {initiative?.description}
      </Typography>

      <Box sx={styles.detailGrid}>
        <Box sx={styles.detailCol}>
          <Box>
            <Typography sx={styles.detailLabel}>Owner</Typography>
            <Typography variant="body2" sx={styles.ownerText}>
              {initiative?.owner}
            </Typography>
          </Box>
          <Box>
            <Typography sx={styles.detailLabel}>Product</Typography>
            <Box sx={styles.chipsBox}>
              {initiative?.product?.map((product) => (
                <LookupChip key={product} label={product} variant="outlined" />
              ))}
            </Box>
          </Box>
          <Box>
            <Typography sx={styles.detailLabel}>Target Period</Typography>
            <Typography variant="body2">
              {initiative?.targetPeriod || "—"}
            </Typography>
          </Box>
          <Box>
            <Typography sx={styles.detailLabel}>Estimate</Typography>
            <Typography variant="body2">
              {initiative?.estimate}{" "}
              {initiative?.estimate === 1 ? "quarter" : "quarters"}
            </Typography>
          </Box>
          <Box>
            <Typography sx={styles.detailLabel}>Progress</Typography>
            <ProgressBar initiative={initiative} />
          </Box>
        </Box>

        <Box sx={styles.detailCol}>
          <Box>
            <Typography sx={styles.detailLabel}>Impact Areas</Typography>
            {initiative?.impactAreas?.length > 0 ? (
              <Box sx={styles.chipsBox}>
                {initiative.impactAreas.map((area) => (
                  <LookupChip key={area} label={area} variant="outlined" />
                ))}
              </Box>
            ) : (
              <Typography variant="body2">—</Typography>
            )}
          </Box>
          <Box>
            <Typography sx={styles.detailLabel}>GitLab Epic</Typography>
            {initiative?.gitlabEpic?.length > 0 ? (
              <Stack sx={styles.linkStack}>
                {initiative.gitlabEpic.map((link, i) => (
                  <CopyLinkRow key={i} link={link} />
                ))}
              </Stack>
            ) : (
              <Typography variant="body2">—</Typography>
            )}
          </Box>
          <Box>
            <Typography sx={styles.detailLabel}>Design Link</Typography>
            {initiative?.designLink?.length > 0 ? (
              <Stack sx={styles.linkStack}>
                {initiative.designLink.map((link, i) => (
                  <CopyLinkRow key={i} link={link} />
                ))}
              </Stack>
            ) : (
              <Typography variant="body2">—</Typography>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
}
